/**@description Role based views constant */
export const Roles = {
    'Factory Reset': ['SupportAdmin', 'SupportTechnician', 'ManufacturingEngineer'],
    'Réinitialisation d\'usine': ['SupportAdmin', 'SupportTechnician', 'ManufacturingEngineer'],
    'Product Owner': ['ProductOwner'],
    'Edge Platform Menu': [
        'MaestroDeviceEventsManager',
        'MaestroContainerLogs',
        'MaestroPackageSecretDataReader',
        'MaestroPackageManager',
        'MaestroApplicationConfigSubmitDiscard',
        'MaestroApplicationConfigUploader',
        'MaestroApplicationConfigManager',
        'MaestroApplicationCreator',
        'MaestroApplicationManager',
        'MaestroContainerActions',
        'MaestroPackageSubmit',
        'MaestroPackageDeploymentManager',
        'MaestroPackageDeploymentCreator',
        'MaestroPackageDeploymentCancel',
        'MaestroFirmwareManager',
        'MaestroDeviceManager',
        'MaestroFirmwareDeploymentsManager',
        'MaestroFirmwareDeploymentsDeployer',
        'MaestroSystemEventsManager',
        'MaestroContentManager',
        'MaestroContainerManager',
        'MaestroDevicePing',
        'MaestroDeviceAcknowledger',
        'MaestroDeviceSecretDataReader'
    ],
    'Propriétaire de produit': ['ProductOwner'],
    'Rules': ['AnalyticscRulesContributor'],
    'Règles':['AnalyticscRulesContributor'],
    'SMP Files Analytics': ['AnalyticscRulesContributor'],
    'Analyse des fichiers SMP':['AnalyticscRulesContributor'],
    'Rules': ['AnalyticscRulesContributor'],
    'Règles':['AnalyticscRulesContributor'],
    'Operational Analytics': ['OperationalAnalytics'],
    'Analyse des données opérationelles':['OperationalAnalytics'],
    'Register Customer': ['SupportAdmin', 'SupportTechnician'],
    'Enregistrer un client':['SupportAdmin', 'SupportTechnician'],
    'Register Customer Site': ['SupportAdmin', 'SupportTechnician'],
    'Enregistrer le Site du Client':['SupportAdmin', 'SupportTechnician'],
    'Find Device By Registration Key': ['SupportAdmin', 'SupportTechnician'],
    'Recherche d’un appareil par clé d’enregistrement':['SupportAdmin', 'SupportTechnician'],
    'Find Device By Type & Serial #': ['SupportAdmin', 'SupportTechnician'],
    'Recherche d’un appareil par type et numéro de série': ['SupportAdmin', 'SupportTechnician'],
    'List Devices': ['SupportAdmin', 'SupportTechnician'],
    'Liste des appareils': ['SupportAdmin', 'SupportTechnician'],
    'Yukon System Health': ['YukonSupport'],
    'Yukon Systems': ['YukonSupport'],
    'Systèmes Yukon': ['YukonSupport'],
    'System Health': ['YukonSupport'],
    'Santé du système': ['YukonSupport'],
    'Metrics & Data Flow Diagrams': ['YukonSupport'],
    'Métriques et diagrammes de flux': ['YukonSupport'],
    'Metrics Explorer': ['YukonSupport'],
    'Explorateur de métriques': ['YukonSupport'],
    'Device Registration': ['SupportAdmin', 'ManufacturingEngineer'],
    'Enregistrement de l’appareil': ['SupportAdmin', 'ManufacturingEngineer'],
    'DTPG Configuration Tool': ['DTPGUser'],
    'LCRs Management': ['DevicesManagementAdmin'], 
    'Gestion des relais de contrôle': ['DevicesManagementAdmin'],
    'License Management': ['EntitlementAdminRole'],
    'Gestion des licences': ['EntitlementAdminRole']
};
